import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ILoyaltyPointState } from '../redux/LoyaltyPoints.reducer';
import { default as UserState } from 'network/response/UserResponse';
import { redeemLoyaltyPoints, removeRedeemedLoyaltyPoints } from '../redux/LoyaltyPoints.actions';
import { ICartState } from 'pages/Cart/redux/reducer';
import { isExisty } from 'utils/helpers.util';
import useGetUrlParams from 'utils/useGetUrlParams';

const getTotalPoints = (voucher: any, totalPoints: number, cartTotalAmount: number) => {
  if (voucher) {
    return voucher.currencyValue.value;
  } else {
    return totalPoints > cartTotalAmount ? cartTotalAmount : totalPoints;
  }
};

interface IState {
  removeCashback: boolean;
  loyaltyPoints: any;
  redeemPoints(redeemedAmount: number, isFullCartRedemption: boolean): void;
  removeRedeemedPoints(isFullCartRedemption: boolean): void;
}

const useLoyaltyPoints = (): IState => {
  const dispatch = useDispatch();
  const loyaltyPoints = useSelector(
    (state: { loyalty: ILoyaltyPointState; user: UserState; cart: ICartState }) => {
      const {
        cart: {
          cartData: { loyaltyVouchers, totalPrice: { value: cartTotalAmount = 0 } = {} },
        },
        user: { currency: { name = '' } = { name: '' } },
      } = state;

      const voucher = isExisty(loyaltyVouchers) ? loyaltyVouchers[0] : null;
      const { totalPointsValue, totalPoints } = state.loyalty;
      const redeemed = isExisty(voucher);

      return {
        totalPointsValue: getTotalPoints(voucher, totalPointsValue, cartTotalAmount),
        currency: name,
        redeemed,
        redeemedAmount: redeemed && voucher ? voucher.currencyValue : {},
        isFullCartRedemption: totalPointsValue >= cartTotalAmount,
        totalPointsAmount: totalPointsValue,
        totalPoints,
        cartTotalAmount,
      };
    }
  );

  const redeemPoints = useCallback(
    (redeemedAmount: number, isFullCartRedemption: boolean) => {
      dispatch(redeemLoyaltyPoints(redeemedAmount, isFullCartRedemption));
    },
    [dispatch]
  );

  const removeRedeemedPoints = useCallback(
    (isFullCartRedemption: boolean) => {
      dispatch(removeRedeemedLoyaltyPoints(isFullCartRedemption));
    },
    [dispatch]
  );

  const errorParams = useGetUrlParams('error');
  const reasonParams = useGetUrlParams('reason_code');

  return {
    loyaltyPoints: {
      ...loyaltyPoints,
    },
    redeemPoints,
    removeRedeemedPoints,
    removeCashback: reasonParams.searchString !== null || errorParams.searchString !== null,
  };
};

export default useLoyaltyPoints;
